<template>
  <div
    :title="course.title"
    class="course-container py-5"
    v-if="course" style="margin: auto !important;"
  >
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div class="course-card" v-bind="attrs" v-on="on" role="button">
          <img
            loading="lazy"
            :src="course.portada_url"
            alt="no image"
            class="img-fluid img-card"
            style="
              border-radius: 20px 20px 0px 0px;
            "
            @click="openProductInfo()"
          >
          <div class="icon-container">
            <img src="../../../assets/play.svg" alt="play">
          </div>
          <div class="extra-info-container text-color py-3">
            <div
              v-if="course.precio > 0"
              class="first-row text-white text-center"
            >
              <div class="row-info">
                <div style="height: 48px; overflow: hidden">
                  <span class="text-left curso">{{ course.nombre }}</span>

                </div>
                
                <span class="text-left text-secondary" style="color: white !important;"
                  ><img
                    src="../../../assets/minicertificate.svg"
                    alt="incluye-certificado"
                    style="margin-right: 8px;"
                  />Incluye certificado</span
                >
                <span class="text-left text-secondary" style="color: white !important;"
                  ><img src="../../../assets/minicertificate.svg" alt="100% virtual" style="margin-right: 8px;" />100%
                  virtual</span
                >

                S/. {{ course.precio.toFixed(2) }}
                <p>
                  
                </p>
              </div>
              <div class="row justify-content-center mt-1 ">
                <div class="col-3 " role="button"><button aria-label="click-whatsapp"> <img class="border border-warning px-3 rounded-lg " src="../../../assets/wtsp.svg" alt="whatsapp" style="padding: 5px;"></button></div>
                <div class="col-auto" role="button"> <button aria-label="click-Comprar" class="btn btn-warning px-4 rounded-lg " style="font-weight: bold; color: black;" @click="openPaymentModal()">Comprar</button></div>
                <div class="col-3 " role="button"><button aria-label="click-carritoCompras"><img class="border border-warning px-3 rounded-lg cartProductBtn" src="../../../assets/shoppingcar.svg" @click="addCartItem()" alt="compras" style="padding: 5px;"></button></div>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>
      </template>
      <span>{{ course.nombre }}</span>
    </v-tooltip>
  </div>
  
</template>

<script>
import { useProductInfo } from '../../../store/productModal';
import { usePaymentModal } from '../../../store/paymentModal';
import { useShoppingCart } from '../../../store/shoppingCart';

export default {
    name: "ProductCard",
    data() {
        return {
        };
    },
    props: {
        course: {
            type: Object,
        },
        mode: {
            type: String,
            default: "private",
        },
        // showPrivateNavbar: {
        //   type: Boolean,
        //   default: false,
        // },
        width: Number,
        height: {
            type: String,
            default: "100%",
        },
        
    },
    methods: {
        getProductType(id) {
            if (id == 1) {
                return "curso";
            }
            else if (id == 2) {
                return "diplomado";
            }
        },
        openProductInfo(){
          const newProduct = this.course
          useProductInfo().updateModalInfo(newProduct)
          this.$emit('openProductInfo')
        },
        openPaymentModal(){
          const newProduct = this.course
          usePaymentModal().updateModalInfo(newProduct)
          this.$emit('openPaymentModal')
        },
        addCartItem(){
          const newProduct = this.course
          useShoppingCart().addCartItem(newProduct)
          console.log(useShoppingCart().$state.cartProducts)
        }
    },
    components: {
    },
};
</script>

<style scoped>
.cartProductBtn:hover{
  fill: white;
}

.icon-container {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-60%, -50%);
  z-index: 1; /* Para que el icono esté encima de la imagen */
}

.icon-container img{
  width: 200%;
  cursor: pointer;
}

.course-card {
  position: relative; /* Necesario para que el icon-container esté posicionado relativo a este contenedor */
  
}
.course-container {
  /* border-top-left-radius: 30px;
  border-top-right-radius: 30px; */
  transition: 0.5s;
  max-width:315px;
  min-width: 265px;
  font-family:Segoe UI ;
}

.course-card:hover .img-card {
  filter: brightness(0.3);
  transition: 0.5s;
  cursor: pointer;
}
.course-card:hover .icon-container {
  color: white;
  transition-duration: 100ms;
  cursor: pointer;
}


.text-color {
  background-color: #131b1e;
}

.extra-info-container {
  display: flex;
  flex-direction: row;
  border-radius: 0px 0px 20px 20px;
  justify-content: space-around;
  align-items: center;
  padding: 5px 0px;
  height: auto;
  padding: 20px;
}
.row-info {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  padding: 0 20px;
}

.row-info button {
  font-size: 14px;
  font-weight: 700;
  padding: 5px 5px;
  border-radius: 8px;
}
.curso {
  font-size: 16px;
  font-weight: 600;
}
.first-row {
  font-size: 1.2em;
  /* text-decoration-line: line-through; */
}
</style>
